import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import moment from "moment";

import { cleanDateFormat } from "utils/cleanDateFormat";
import { replaceHashValues } from "utils/replaceHashValues";

import Modal from "common-components/Modal/Modal";
import Link from "common-components/StyledLink";

function formatDate(date) {
  return moment(date)
    .format("MMM DD, YYYY")
    .toString();
}

const PendingRequest = ({
  downloadAvailabilityDeadline,
  dateOfRequest,
  downloadPending,
  downloadPendingContent,
  downloadReadyContent,
  closeModal,
  ...props
}) => (
  <Modal contentLabel="pending request modal">
    {downloadPending ? (
      <Fragment>
        <H2>{downloadPendingContent.section_title}</H2>
        <Div>
          {convertStringToElements(
            replaceHashValues(downloadPendingContent.section_description, {
              requesteddate: formatDate(cleanDateFormat(dateOfRequest))
            })
          )}
        </Div>

        <Link to="/privacy/secure/download-status" background={downloadPendingContent.buttons[0].type}>
          {downloadPendingContent.buttons[0].text}
        </Link>
      </Fragment>
    ) : (
      <Fragment>
        <H2>{downloadReadyContent.section_title}</H2>
        <Div style={{ maxWidth: "409px" }}>
          <p>
            {convertStringToElements(
              replaceHashValues(downloadReadyContent.section_description, {
                expirydate: formatDate(downloadAvailabilityDeadline)
              })
            )}
          </p>
        </Div>
        <Link
          to={{
            pathname: "/privacy/secure/download-status",
            state: {
              downloadReady: true
            }
          }}
          background={downloadReadyContent.buttons[0].type}
        >
          {downloadReadyContent.buttons[0].text}
        </Link>
      </Fragment>
    )}
  </Modal>
);

PendingRequest.propTypes = {
  downloadAvailabilityDeadline: PropTypes.string,
  dateOfRequest: PropTypes.string,
  downloadPending: PropTypes.bool.isRequired,
  downloadPendingContent: PropTypes.object,
  downloadReadyContent: PropTypes.object
};

export default PendingRequest;

const Div = styled.div`
  margin-bottom: 40px;
  max-width: ${window.reactGlobals && window.reactGlobals.amLob === "vzt" ? "410px" : "450px"};

  p {
    padding: 10px 0;
  }
`;

const H2 = styled.h2`
  max-width: 410px;
  margin-bottom: 24px;
`;
